import { updateSuccessMessage } from '@common/api/graphql/successMessage';
import { updateDistributionPartnerUser } from '@common/api/graphql/updateDistributionPartnerUserGql';
import type { UpdateDistributionPartnerUserParams } from '@common/api/graphql/updateDistributionPartnerUserGql';
import type { AppState } from '@console/reducers';
import type { ApiError } from '../../../../common/api/graphql/apolloClient';
import {
  updateDistributionPartnerUserFailure,
  updateDistributionPartnerUserStart,
  updateDistributionPartnerUserSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';
import handleApiErrorIfNeeded from './handleApiErrorIfNeeded';

export const getUpdateDistributionPartnerUserRequestParams = (
  state: AppState
): UpdateDistributionPartnerUserParams => {
  const distributionPartnerUser = state.edits.distributionPartnerUser;
  return {
    name: distributionPartnerUser.name,
    division: distributionPartnerUser.division,
    phoneNumber: distributionPartnerUser.phoneNumber
  };
};

export const updateDistributionPartnerUserSuccessThunk =
  (): AppThunkAction<Promise<void>> => dispatch => {
    const snackbarMessage = updateSuccessMessage('ユーザ情報');
    dispatch(updateDistributionPartnerUserSuccess(snackbarMessage));
    return Promise.resolve();
  };

export const updateDistributionPartnerUserFailureThunk =
  (error: ApiError): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(updateDistributionPartnerUserFailure());
    return dispatch(handleApiErrorIfNeeded(error));
  };

export const updateDistributionPartnerUserThunk =
  (): AppThunkAction<Promise<void>> => (dispatch, getState) => {
    const updateDistributionPartnerUserRequestParams =
      getUpdateDistributionPartnerUserRequestParams(getState());
    dispatch(updateDistributionPartnerUserStart());
    return updateDistributionPartnerUser(
      updateDistributionPartnerUserRequestParams
    )
      .then(() => dispatch(updateDistributionPartnerUserSuccessThunk()))
      .catch(error =>
        dispatch(updateDistributionPartnerUserFailureThunk(error))
      );
  };
